// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Header_wrapper__2C9fU","main":"Header_main__1K-_6","title":"Header_title__SzZyf","auth":"Header_auth__r-nYk","nameContainer":"Header_nameContainer__3t9w4"};